export default "__VITE_ASSET__7a487a02__"